export class SerializeObjectContext {
    target;
    constructor(init) {
        Object.assign(this, init);
    }
}
